/* global olark */
import $ from 'jquery'

const Support = {
  init: function () {
    $('.js-help-dropdown, .link-help')
      .on('mouseenter', function () {
        $(this).find('ol').fadeIn(100)
      })
      .on('mouseleave', function () {
        $(this).find('ol').fadeOut(100)
      })

    $('.js-open-chat, .link-chat').on('click', function (event) {
      event.preventDefault()

      const chatLink = $(this)

      if (chatLink.hasClass('status-offline')) {
        chatLink
          .find('.chat-status')
          .animate(
            {
              opacity: 0.1,
            },
            250
          )
          .animate(
            {
              opacity: 1,
            },
            250
          )

        return
      }

      if (typeof olark !== 'undefined') {
        olark('api.box.expand')
      }
    })
  },

  olark: function () {
    olark.extend(function (api) {
      api.chat.onOperatorsAvailable(function () {
        Support.setChatStatus('online')
      })

      api.chat.onOperatorsAway(function () {
        Support.setChatStatus('offline')
      })

      api.chat.onOperatorsBusy(function () {
        Support.setChatStatus('offline')
      })

      if (api.chat.operatorsAreAway()) {
        Support.setChatStatus('offline')
      }
    })
  },

  setChatStatus: function (status) {
    const chatLink = $('.js-open-chat, .link-chat')

    if (status === 'online') {
      chatLink.addClass('status-online').removeClass('status-offline')
    } else {
      chatLink.addClass('status-offline').removeClass('status-online')
    }
  },
}

$(Support.init)

window.onload = function () {
  if (typeof olark !== 'undefined') {
    Support.olark()
  }
}
